import type { RefObject } from "react";
import { useEffect, useState } from "react";

type Dimensions = {
  width: number;
  height: number;
  top: number;
  left: number;
};

export const useResizeObserver = (
  ref: RefObject<HTMLElement | null>,
): Dimensions | undefined => {
  const [dimensions, setDimensions] = useState<Dimensions>();

  useEffect(() => {
    const referenceNode = ref.current;
    if (!referenceNode) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      setDimensions(entries[0].contentRect);
    });

    resizeObserver.observe(referenceNode);

    return () => {
      if (!referenceNode) {
        return;
      }
      resizeObserver.unobserve(referenceNode);
    };
  }, [ref]);

  return dimensions;
};
